import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/resources/")({
    beforeLoad: () => {
        throw redirect({ to: "/dashboard/resources/csp-view" });
    },
});
